"use client";

import { Share as ShareIcon } from "@mui/icons-material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useIntl } from "react-intl";

import { SnackStack } from "../../snack-stack/ui";

type ShareKind = "collection" | "show";

export function ViewBoxAppBarShareButton({
  id,
  tmdbMediaType,
  kind = "show",
}: {
  id: number;
  tmdbMediaType: "movie" | "tv";
  kind?: ShareKind;
}) {
  const { formatMessage } = useIntl();

  const handleShare = async () => {
    try {
      const shareUrl = (() => {
        if (kind === "show") {
          return `https://ot.viewbox.dev/${tmdbMediaType}/${id}?utm_source=share`;
        }

        return `https://ot.viewbox.dev/genre/${tmdbMediaType}/${id}?utm_source=share`;
      })();

      if (navigator.share) {
        const shareData: ShareData = {
          text: shareUrl,
        };

        if (!navigator.canShare(shareData)) {
          return;
        }

        await navigator.share(shareData);

        return;
      }

      await navigator.clipboard.writeText(shareUrl);

      await SnackStack.queue(
        formatMessage({ id: "share_btn_copied" }),
        1500,
        "success",
      );
    } catch (err) {
      if ((err as Error)?.name === "AbortError") {
        return;
      }

      console.error(err);
    }
  };

  return (
    <Box>
      <Tooltip title={formatMessage({ id: "app_bar_share" })}>
        <IconButton color="inherit" onClick={handleShare}>
          <ShareIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
